import { ThemeProperties } from '../../core';

export interface ColorSwatchTheme {
	baseSize: string;
	baseBorderRadius: string;
}

export const theme = new ThemeProperties('colorSwatch');
